import { MypageMessageFormat } from "~/extensions/utils/DefineFunction";
import { commonStore } from "~/store/CommonStore";
const allowedExtensions = new Set(["jpeg", "jpg", "png", "pdf"]);
const maxFileCount = 10;
const maxFileSize = 10485760;
const maxTotalFileSize = 104857600;
export function validateSelectedFiles(files, row) {
    const activeFileCount = row.fileList.filter(file => !file.delFlg).length;
    if (files.length + activeFileCount > maxFileCount) {
        return MypageMessageFormat(commonStore.messages.PV0010, { val: String(maxFileCount) });
    }
    let totalFileSize = 0;
    for (const file of files) {
        const extension = file.name.split(".").pop()?.toLowerCase() ?? "";
        if (!allowedExtensions.has(extension)) {
            return commonStore.messages.PV0008;
        }
        if (file.size > maxFileSize) {
            return MypageMessageFormat(commonStore.messages.PV0009, { val: "ファイル", val1: "10MB" });
        }
        totalFileSize += file.size;
    }
    if (totalFileSize > maxTotalFileSize) {
        return MypageMessageFormat(commonStore.messages.PV0009, { val: "合計ファイル", val1: "100MB" });
    }
    return "";
}
